import React from 'react';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { Box, Button, Tooltip, Typography } from '@mui/material';
import type { ChipProps, Theme } from '@mui/material';
import { StatusChipWithTooltip } from '~/modules/guarantees/legacy/StatusChipWithTooltip.tsx';
import { guaranteesApplicationStatusStyles } from './guaranteesApplicationStatusStyles.ts';
import { appFormStyles, commonStyles } from '~/modules/guarantees/legacy/styles.ts';

export interface IApplicationHeaderProps {
  applicationNumber: string;
  applicationNumberLabel: string;
  applicationNumberTooltip?: string;
  applicationIdLabel: string;
  backLabel: string;
  contragentId: string;
  contragentIdLabel: string;
  effectiveApplicationId: string;
  statusConfig: {
    color: ChipProps['color'];
    description?: string;
    label: string;
  };
  onBack: () => void;
}

const applicationHeaderStyles = {
  applicationHeaderMeta: (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: { xs: 'flex-start', sm: 'flex-end' },
    gap: theme.spacing(0.5),
    minWidth: 0,
  }),
} as const;

const ApplicationHeader: React.FC<IApplicationHeaderProps> = ({
  applicationNumber,
  applicationNumberLabel,
  applicationNumberTooltip,
  applicationIdLabel,
  backLabel,
  contragentId,
  contragentIdLabel,
  effectiveApplicationId,
  statusConfig,
  onBack,
}) => {
  const shouldShowApplicationId =
    !!effectiveApplicationId && effectiveApplicationId !== applicationNumber;
  const applicationTitle = (
    <Typography variant="h4" sx={appFormStyles.title}>
      {applicationNumberLabel} {applicationNumber}
    </Typography>
  );

  return (
    <>
      <Box sx={commonStyles.backRow}>
        <Button
          type="button"
          variant="text"
          startIcon={<ArrowBackIcon />}
          onClick={onBack}
          sx={commonStyles.backButton}
        >
          {backLabel}
        </Button>
      </Box>

      <Box sx={appFormStyles.header}>
        {applicationNumberTooltip ? (
          <Tooltip title={applicationNumberTooltip}>{applicationTitle}</Tooltip>
        ) : (
          applicationTitle
        )}

        <Box sx={appFormStyles.metaRow}>
          <Box sx={appFormStyles.status}>
            <StatusChipWithTooltip
              label={statusConfig.label}
              color={statusConfig.color}
              size="medium"
              description={statusConfig.description}
              chipSx={guaranteesApplicationStatusStyles.chip}
            />
          </Box>

          <Box sx={applicationHeaderStyles.applicationHeaderMeta}>
            <Typography variant="body2" sx={appFormStyles.createdAt}>
              {contragentIdLabel}: {contragentId}
            </Typography>

            {shouldShowApplicationId && (
              <Typography variant="body2" sx={appFormStyles.createdAt}>
                {applicationIdLabel}: {effectiveApplicationId}
              </Typography>
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ApplicationHeader;
